// Services
import PaymentService from '@/app/services/main/payment/payment-service.js';
import ProductService from '@/app/services/main/product/product-service';
import TransactionService from '@/app/services/main/transaction/transaction-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';
import { GA } from '@/app/constants/ga-constants';
import { FREQUENCY_CODE, TRANSLATE_PERIOD } from '@/app/constants/subscription-constants';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

export default {
	name: 'TransactionSuccessContainer',
	mixins: [
		toastMessageMixins,
		GoogleAnalyticsMixins,
		dateMixins,
		userMixins
	],
	data() {
		return {
			isAPILoading: false,
			// table
			theads: [
				{ name: 'Image', sortLabel: null, isDesc: false, style: null},
				{ name: 'Products', sortLabel: null, isDesc: false, style: null},
				{ name: 'Quantity', sortLabel: null, isDesc: false, style: null},
				{ name: 'Price', sortLabel: null, isDesc: false, style: 'width: 100px;'},
			],
			subHeads: [
				{ name: 'Image', sortLabel: null, isDesc: false, style: null},
				{ name: 'Products', sortLabel: null, isDesc: false, style: null},
				{ name: 'Frequency', sortLabel: null, isDesc: false, style: null},
				{ name: 'Period', sortLabel: null, isDesc: false, style: null},
				{ name: 'Price', sortLabel: null, isDesc: false, style: 'width: 100px;'}
			],
			orderDetails: null,
			location: '',
			transactionDetails: null,
			dogDetails: null,
			ageList: {
				A: 'Adult',
				P: 'Puppy'
			},
		}
	},
	computed: {
		getSelectedCartContent() {
			return this.$store.getters.getSelectedCartContent;
		},
		getIfSubscription() {
			let flag = false;

			if (this.getSelectedCartContent && this.getSelectedCartContent.length > 0) {
				flag = this.getSelectedCartContent[0].subscriptionBundle;
			}

			return flag;
		}
	},
	created() {
		this.updatePaymentStatus();
	},
	methods: {
		updatePaymentStatus(){
			const {
				gatewayReference,
                merchantReference,
                transactionReference,
                location
			} = this.$store.getters.getLatitudePay;

			const paymentDetails = {
				gatewayReference,
                merchantReference,
                transactionReference,
			}
			this.location = location;
			this.isAPILoading = true;

			PaymentService.updateStatusLatitudePay(paymentDetails)
				.then(response => {
					if (response.status !== STATUS_CODES.SUCCESS) {
						this.$router.push('/transaction-failed-page'); 
						this.showAPIErrorToast('Unable to update payment status.', response);
					} else {
						if(response.data.result.status === "failed"){
							this.$router.push(`/transaction-failed-page?message=${response.data.result.message}`); 
							
						}
						if (location === 'dog-purchase') {
							TransactionService.getTransactionDogOrderById(response.data.orderId)
								.then(res => {
									if (res.status === STATUS_CODES.SUCCESS) {
										this.transactionDetails = res.data;
									} else {
										this.$router.push('/transaction-failed-page'); 
										this.showAPIErrorToast('Unable to get transaction details.', res);
									}
									this.$store.commit('clearLatitudePay');
								})
								.catch(() => {
									this.$router.push('/transaction-failed-page'); 
									this.showGenericErrorToast();
								})
								.finally(() => {
									this.isAPILoading = false;
								});
						}
					}
					// Send Analytics
					this.sendEventTrackingToGA(GA.REQUEST_DOG_PURCHASE_SUCCESS_PAGE.ON_PAGE_LOAD.ACTION, GA.REQUEST_DOG_PURCHASE_SUCCESS_PAGE.CATEGORY, GA.REQUEST_DOG_PURCHASE_SUCCESS_PAGE.ON_PAGE_LOAD.LABEL);
				})
				.catch(() => {
					this.$router.push('/transaction-failed-page'); 
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isAPILoading = false;
				});
		},
		getDogDetails(location, productId) {
			if (location === 'dog-purchase') {
				// Get dog details based on productId coming from vuex and url from latitudepay
				ProductService.getProductsDogDetails(productId)
				.then(result => {
					if (result.status === STATUS_CODES.SUCCESS) {
						this.dogDetails = result.data;
					}
				})
			} else {
				// Get the cart details in vuex
				this.getTransactionDetails();
			}
		},
		getTransactionDetails() {
			const orders = JSON.parse(JSON.stringify(this.getSelectedCartContent));

			this.orderDetails = orders.map(order => {
				let detail = {};

				if (order.subscriptionBundle) {
					detail = {
						id: order.bundleId,
						name: order.name,
						age: order.age,
						imageUrl: order.bundleImg,
						price: order.price,
						cartPaymentFrequency: FREQUENCY_CODE[order.cartPaymentFrequency],
						cartSubscriptionPeriod: TRANSLATE_PERIOD[order.cartSubscriptionPeriod]
					}
				} else {
					detail = {
						id: order.bundleId,
						name: order.name,
						age: order.age,
						imageUrl: order.bundleImg,
						price: order.price,
						quantity: order.quantity
					}
				}

				return detail;
			});
		},
		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`;
			}
		}
	}
}